<template>
    <BaseCountCard :value="TPAppsStats.TPAppsTotalCount" unit="طلب على منح البرامج التدريبية" />
</template>
<script>
import { useStatisticsStore } from '@/modules/home/store/StatisticsStore';
import { mapState } from 'pinia';
import BaseCountCard from '../../base_statistics_cards/BaseCountCard.vue';

export default{
    components: { BaseCountCard },
    computed:{
        ...mapState(useStatisticsStore,["TPAppsStats"]),
    }
}
</script>